export class NeqTableData<T> {
  pageIndex = 1;
  results: Array<T> = [];
  totalElements = 0;
  paginate = false;
}
